/**
 * Rimozione dichiarativa di elementi DOM in base al ruolo utente.
 *
 * Uso: <button data-perm="operatore,amministratore">...</button>
 * Se currentUser non esiste o il suo ruolo non è nella lista, l'elemento viene rimosso.
 */

declare const currentUser: { ruolo?: string } | undefined;

export function hasPerm(requiredPerm: string): boolean {
  const ruolo = typeof currentUser !== 'undefined' ? currentUser?.ruolo : undefined;
  if (!ruolo) return false;
  const allowed = requiredPerm.split(',').map(s => s.trim());
  return allowed.includes(ruolo);
}

export function enforcePerm(container: Element | Document = document): void {
  for (const el of container.querySelectorAll<HTMLElement>('[data-perm]')) {
    if (!hasPerm(el.dataset.perm!)) {
      el.remove();
    }
  }
}
